module.exports = __webpack_public_path__ + "static/resilienceFramework.8f3dbddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/multires/resilienceFramework.png
// module id = 891
// module chunks = 42612325933423 52555556726803